import Beans3 from '@/beans';
import { i18n, riperStorage } from '@/base/helpers';

const icons = {
  reward: 'https://cdn.trybeans.com/static-v3/snow/emoji/reward-program.svg',
  discount: 'https://cdn.trybeans.com/static-v3/snow/emoji/discount.svg',
  error: 'https://cdn.trybeans.com/static-v3/snow/emoji/discount.svg',
};

const Widget = {
  listen() {
    const { onAbout, onLogin, onRegister } = riperStorage;
    const snow = window.Beans3.Snow;
    snow.listen('snow:liana:about', onAbout);
    snow.listen('snow:liana:dashboard', onAbout);
    snow.listen('snow:liana:login', onLogin);
    snow.listen('snow:liana:register', onRegister);
    snow.listen('snow:liana:redemption-apply', () => window.Beans3.Liana.Redemption.apply());
    snow.listen('snow:liana:redemption-cancel', window.Beans3.Liana.Redemption.cancel);
    snow.listen('snow:liana:redemption-status', () => snow.delete('snow:liana:redemption'));
    snow.listen('snow:liana:redemption-status-error', () => snow.delete('snow:liana:redemption-error'));
  },
  showMessageDefault(reset) {
    Beans3.require('snow').then(function () {
      const { account, riperDisplay: display, cart, coupon, currentPage } = riperStorage;
      const beansName = display && display.beans_name;
      const minBeans = display && display.redemption.min_beans;
      const maxPercentage = display && display.redemption.max_percentage;
      const isItemInCart = cart && cart.item_count;
      const snow = window.Beans3.Snow;
      reset && snow.delete('snow:liana:about');
      reset && snow.delete('snow:liana:redemption');
      if (account && coupon && coupon.uid) {
        snow.toast({
          id: 'snow:liana:redemption',
          tagline: i18n.t('redemption', 'you_have_redeemed', { beans_name: beansName }),
          ctaEvent: 'snow:liana:redemption-cancel',
          icon: icons.discount,
        });
      } else if (account && account.beans < minBeans && isItemInCart) {
        snow.toast({
          id: 'snow:liana:about',
          tagline: i18n.t('redemption', 'not_enough_point'),
          ctaEvent: 'snow:liana:about',
          icon: icons.reward,
        });
      } else if (account && isItemInCart) {
        const redemptionValue = Math.min(account.beans, (cart.total_price * maxPercentage) / 100);
        snow.toast({
          id: 'snow:liana:redemption',
          tagline: i18n.t('redemption', 'redeem_points', {
            quantity: redemptionValue.toLocaleString(),
            beans_name: beansName,
          }),
          ctaEvent: 'snow:liana:redemption-apply',
          icon: icons.discount,
        });
      } else if (account) {
        snow.toast({
          id: 'snow:liana:about',
          tagline: i18n.t('snow', 'you_have_points', {
            beans_balance: account.beans.toLocaleString(),
            beans_name: beansName,
          }),
          ctaEvent: 'snow:liana:about',
          icon: icons.reward,
        });
      } else if (currentPage === 'reward') {
        snow.toast({
          id: 'snow:liana:about',
          tagline: i18n.t('snow', 'register_now', { beans_name: beansName }),
          ctaEvent: 'snow:liana:register',
          icon: icons.reward,
        });
      } else {
        snow.toast({
          id: 'snow:liana:about',
          tagline: i18n.t('snow', 'join_rewards_program', { beans_name: beansName }),
          ctaEvent: 'snow:liana:about',
          icon: icons.reward,
        });
      }
    });
  },
  showMessageError(message) {
    Beans3.require('snow').then(function () {
      const snow = window.Beans3.Snow;
      snow.delete('snow:liana:error');
      snow.delete('snow:liana:redemption');
      snow.toast({
        id: 'snow:liana:error',
        tagline: message,
        ctaEvent: 'snow:liana:redemption-status-error',
        icon: icons.error,
      });
    });
  },
  showMessageRedemptionState(message, ctaEvent) {
    Beans3.require('snow').then(function () {
      const snow = window.Beans3.Snow;
      snow.delete('snow:liana:error');
      snow.delete('snow:liana:redemption');
      snow.toast({
        id: 'snow:liana:redemption',
        tagline: message,
        ctaEvent: ctaEvent || 'snow:liana:redemption-status',
        icon: 'https://cdn.trybeans.com/static-v3/snow/emoji/discount.svg',
      });
    });
  },
  init() {
    Widget.listen();
    Widget.showMessageDefault();
  },
};

export default Widget;
